import { combineReducers } from 'redux';
import storeState from './appReducer';
export default combineReducers({
  storeState
});